<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        การจัดการ กลุ่มสิทธิ์
      </span>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="handleAddTaRightsGroupForm">
        <v-icon small left>mdi-plus</v-icon>เพิ่มกลุ่มสิทธิ์
      </v-btn>
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="taRightsGroup"
      :custom-filter="customFilter"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.hardware_group="{ item }">
        {{ item.hardware_group.title_th }}
      </template>
      <template v-slot:item.employee_group="{ item }">
        {{ item.employee_group.title_th }}
      </template>
    </v-data-table>
    <TaRightGroupForm
      :formShow="taRightGroupFormShow"
      :formAction="taRightGroupFormAction"
      :taRightGroup="taRightGroup"
      :taRightGroupInit="taRightGroupInit"
      @isTaRightGroupDataChange="handleTaRightGroupFormDataChange"
      @formActionCompleted="handleTaRightGroupFormActionCompleted"
      @onReset="handleTaRightGroupFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="taRightGroupFormShow && taRightGroupFormAction === 'add'"
      z-index="0"
    ></v-overlay>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TaRightGroupForm from '@/views/ta-rights-group/TaRightGroupForm.vue'

export default {
  components: {
    TaRightGroupForm,
    ConfirmDialog,
  },
  data() {
    return {
      sortBy: ['title_th'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      taRightGroupFormShow: false,
      taRightGroupFormAction: '',
      taRightGroup: {},
      taRightGroupInit: {},
      isTaRightGroupDataChange: false,
      timeout: null,
    }
  },
  computed: {
    headers() {
      return [
        { text: 'คำอธิบาย (ไทย)', align: 'start', value: 'title_th' },
        { text: 'กลุ่ม Device', align: 'start', value: 'hardware_group' },
        {
          text: 'จำนวน Device',
          align: 'start',
          value: 'hardware_group.hardware_group_member.total',
        },
        { text: 'กลุ่ม พนักงาน', align: 'start', value: 'employee_group' },
        {
          text: 'จำนวน พนักงาน',
          align: 'start',
          value: 'employee_group.employee_group_member.total',
        },
      ]
    },
    taRightsGroup() {
      return this.$store.state.taRightsGroup.taRightsGroup
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การจัดการ กลุ่มสิทธิ์',
        disabled: true,
      },
    ])

    const { company_uuid } = this.$store.state.authentication.company

    const payload = {
      company_uuid,
    }

    this.loading = true

    Promise.all([
      this.fetchTaRightsGroup(payload),
      this.fetchTaHardwaresGroup(payload),
      this.fetchTaEmployeesGroup(payload),
    ])
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchTaRightsGroup: 'taRightsGroup/fetchTaRightsGroup',
      fetchTaHardwaresGroup: 'taHardwaresGroup/fetchTaHardwaresGroup',
      fetchTaEmployeesGroup: 'taEmployeesGroup/fetchTaEmployeesGroup',
    }),
    customFilter(value, search, item) {
      return (
        item.title_th?.toLowerCase().includes(search.toLowerCase()) ||
        item.title_en?.toLowerCase().includes(search.toLowerCase()) ||
        item.hardware_group?.title_th
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item.employee_group?.title_th
          ?.toLowerCase()
          .includes(search.toLowerCase())
      )
    },
    classRowSelected(row) {
      if (this.taRightGroup.authority_uuid === row.authority_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.taRightGroup.authority_uuid === row.authority_uuid) {
        this.taRightGroupFormShow = false
        this.taRightGroupFormAction = ''
        this.taRightGroup = {}
        this.taRightGroupInit = {}
      } else {
        this.taRightGroupFormShow = true
        this.taRightGroupFormAction = 'edit'
        this.taRightGroup = {
          ...row,
          hardware_group_uuid: row.hardware_group?.hardware_group_uuid,
          employee_group_uuid: row.employee_group?.employee_group_uuid,
        }
        this.taRightGroupInit = {
          ...row,
          hardware_group_uuid: row.hardware_group?.hardware_group_uuid,
          employee_group_uuid: row.employee_group?.employee_group_uuid,
        }
      }
    },
    handleRowSelected(row) {
      if (this.isTaRightGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddTaRightsGroupForm() {
      this.taRightGroupFormShow = true
      this.taRightGroupFormAction = 'add'
      this.taRightGroup = {}
      this.taRightGroupInit = {}
    },
    handleTaRightGroupFormDataChange(value) {
      this.isTaRightGroupDataChange = value
    },
    handleTaRightGroupFormReset(formAction) {
      if (formAction === 'edit') {
        this.taRightGroup = { ...this.taRightGroupInit }
      }
    },
    handleTaRightGroupFormActionCompleted(formAction) {
      if (formAction === 'edit') {
        this.taRightGroup = {}
        this.taRightGroupInit = {}
      }
      this.taRightGroupFormShow = false
      this.taRightGroupFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.taRightGroupFormShow = false
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isTaRightGroupDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
